<template>
	<div class="w-full h-full absolute inset-0 bg-black text-white flex flex-col p-6 space-y-6">
		<div :class="[sidePanels.find(el => el.active) ? 'w-[calc(100%-25rem-(6*4px))]' : 'w-full', 'flex justify-between items-center transition-[width] duration-150 ease-in-out origin-left duration-150 ease-in-out']">
			<div class="flex items-center group">
				<input ref="sessionTitleInput" @change="handleTitleChange" @input="adjustInputWidth" v-if="roomInfo" type="text" v-model="roomInfo.title" class="bg-transparent border-transparent text-lg font-semibold p-1 hover:border-gray-800 focus:border-regal-blue-700 rounded-md focus:ring-0">
				<div v-if="roomInfo" ref="sessionTitleReference" class="fixed invisible font-semibold px-2 text-lg">{{ roomInfo.title }}</div>
			</div>
			<div class="flex items-center space-x-4 text-sm">
<!-- 				<div class="flex items-center space-x-1.5 w-10 h-10 bg-[#1C1C1E] rounded-full justify-center">
					<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
				</div> -->
				
				<div class="bg-[#1C1C1E] text-gray-700 rounded-full px-3 pr-4 h-10 flex items-center justify-center space-x-1.5 text-xs font-semibold">
					<template v-if="appState == 'loading'">
						<svg class="animate-spin h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
							<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
							<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
						</svg>
						<div>Loading</div>
					</template>
					<template v-if="appState == 'idle'">
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
						<div>Ready</div>
					</template>
					<template v-if="appState == 'working'">
						<svg class="animate-spin h-4 w-4 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
							<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
							<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
						</svg>
						<div>Working</div>
					</template>
				</div>
			</div>
		</div>

		<div class="w-full grow flex space-x-6 h-full transition-all duration-150 ease-in-out overflow-hidden">
			<div :class="[sidePanels.find(el => el.active) ? 'w-[calc(100%-25rem-(6*4px))]' : 'w-full', 'transition-[width] duration-150 ease-in-out origin-left duration-150 ease-in-out h-full flex space-x-6']">
				<div class="flex space-x-6 h-full w-full">

					<template v-if="!participants">
						<div class="bg-[#1C1C1E] w-full h-full rounded-2xl overflow-hidden transform-gpu">
							<div class="relative w-full h-full flex items-center justify-center">
								<div class="absolute z-20 w-[20vw] h-[20vw] rounded-full bg-gray-300 bg-center bg-cover flex items-center justify-center text-[5vw] text-gray-600 font-medium" :style="'background-image: url(' + user?.avatar + ')'">
									<span v-if="!user?.avatar">{{ user?.name.charAt(0).toUpperCase() }}{{ user?.name.charAt(1) }}</span>
								</div>
								<div class="absolute z-10 w-[20vw] h-[20vw] bg-gradient-to-br from-regal-blue-700 to-purple-400 rounded-full transform-gpu" :style="'transform: scale(' + volume + ')'"></div>
							</div>
							<!-- <video class="w-full h-full object-cover -scale-x-[1]" autoplay ref="localVideo" /> -->
						</div>
					</template>

					<template v-if="participants">
						<template v-for="p in participants" :key="p.session_id">
							<ParticipantTile :participant="p" />
						</template>
					</template>
				</div>
			</div>
		</div>

		<Transition mode="out-in" enter-from-class="translate-x-[25rem]" enter-to-class="translate-x-0" leave-from-class="translate-x-0" leave-to-class="translate-x-[25rem]">
			<div v-if="sidePanels.find(el => el.active)" class="transition-transform duration-150 ease-in-out absolute right-6 top-0 w-[25rem] shrink-0 h-full max-h-[calc(100vh-8rem)] text-black bg-white rounded-2xl overflow-scroll hide-scroll-bar">
				<div class="z-20 flex items-center justify-between font-medium sticky supports-[backdrop-filter]:bg-white/[0.72] supports-[backdrop-filter]:backdrop-blur-[20px] supports-[backdrop-filter]:backdrop-saturate-[180%] top-0 left-0 px-6 pt-4 pb-4 border-b border-b-gray-400">
					<div>Recordings</div>
					<div class="flex space-x-1 items-center text-gray-800">
						<a v-if="recordings.length" :href="route('rooms.download', roomInfo.uuid)" class="w-10 h-10 rounded-full flex items-center justify-center">
							<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"></path></svg>
						</a>
						<Link :href="route('rooms.show', roomInfo.uuid)" class="w-10 h-10 rounded-full flex items-center justify-center">
							<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path></svg>
						</Link>
					</div>

				</div>
				<div class="grid grid-cols-1 divide-y divide-gray-400 mt-4 px-6">
					<RecordingPreview v-for="recording in recordings.slice().reverse()" :user="user" :recording="recording" :key="recording.uuid" @delete="removeRecording" />
				</div>
			</div>
		</Transition>

		<div class="w-full flex items-center justify-between">
			<div class="w-[25rem] flex items-center"></div>
			<div>
				<div v-if="appState == 'loading'" class="animate-pulse flex space-x-2.5 items-center">
					<div class="w-32 h-14 rounded-2xl bg-[#1C1C1E]"></div>
<!-- 					<div class="w-14 h-14 rounded-2xl bg-[#1C1C1E]"></div>
					<div class="w-14 h-14 rounded-2xl bg-[#1C1C1E]"></div> -->
					<div class="w-14 h-14 rounded-2xl bg-[#1C1C1E]"></div>
				</div>

				<div v-else class="flex space-x-2.5 items-center" >
					<div @click="toggleRecording" :class="[recording ? 'bg-white text-regal-blue-900' : 'bg-red-500 hover:bg-red-600', 'w-32 h-14 rounded-2xl cursor-pointer text-white flex space-x-2.5 items-center justify-center group']">
						<div class="flex items-center justify-center space-x-2.5 w-20">
							<div class="w-3 h-3 relative shrink-0">
								<div v-if="!recording" class="absolute w-3 h-3 bg-red-100 rounded-full group-hover:bg-white"></div>
								<template v-else>
									<div v-if="recording" class="absolute w-3 h-3 bg-red-500 rounded-full"></div>
									<div v-if="recording" class="absolute w-3 h-3 bg-red-500 animate-ping rounded-full"></div>
								</template>
							</div>
							<div :class="[recording ? '' : 'group-hover:text-white', 'text-sm font-semibold grow flex items-center justify-center']">
								<span v-if="!recording">Record</span>
								<template v-else>
									<span class="tabular-nums text-regal-blue-900/[0.77] group-hover:hidden">{{ timeRecorded }}</span>
									<span class="hidden group-hover:block">Stop</span>
								</template>
							</div>
						</div>
					</div>
<!-- 					<div class="w-14 h-14 rounded-2xl bg-[#1C1C1E] flex items-center justify-center text-[#8D8E93] hover:bg-[#242426] cursor-pointer hover:text-white">
						<MicrophoneIcon class="w-5 h-5" />
					</div>
					<div class="w-14 h-14 rounded-2xl bg-[#1C1C1E] flex items-center justify-center text-[#8D8E93] hover:bg-[#242426] cursor-pointer hover:text-white">
						<VideoCameraIcon class="w-5 h-5" />
					</div> -->
					<Link :href="route('studio.index')" class="w-14 h-14 rounded-2xl bg-[#1C1C1E] flex items-center justify-center text-red-600 hover:bg-[#242426] cursor-pointer hover:text-red-500">
						<XIcon class="w-5 h-5" />
					</Link>
				</div>
			</div>
			<div class="w-[25rem] flex items-center justify-end">
				<template v-for="tab in sidePanels">
					<div @click="toggleSidepanel(tab)" :class="[sidePanels.find(el => el.active) ? 'text-white' : 'text-[#8D8E93]', 'w-14 h-14 rounded-2xl flex items-center justify-center  cursor-pointer hover:text-white']">
						<component :is="tab.icon" class="w-6 h-6" />
					</div>
				</template>
			</div>
		</div>
	</div>

    <Modal v-model:open="showPermissionsError">
        <div class="w-full">
        	<div class="font-semibold">Allow Pager to use your microphone: <span class="font-normal text-gray-700">Pager needs access to your microphone to record your voice. Learn how to do this in <a class="underline hover:no-underline" href="https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop">Chrome</a>, <a class="underline hover:no-underline" href="https://support.apple.com/en-gb/guide/safari/ibrwe2159f50/mac">Safari</a>, or <a class="underline hover:no-underline" href="https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions">Firefox</a></span> </div>
        	<div class="w-full flex justify-end mt-4">
        		<Button @click="showPermissionsError = false" label="Got it" />
        	</div>
        </div>
    </Modal>
</template>

<script setup>
import { ref, computed, onMounted, defineProps, onBeforeUnmount } from 'vue'
import daily from '@daily-co/daily-js'
import { usePage } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import { MediaPermissionsError, MediaPermissionsErrorType, requestMediaPermissions } from 'mic-check'
import ParticipantTile from '@/Pages/Recordings/ParticipantTile'
import RecordingPreview from '@/Pages/Recordings/RecordingPreview'
import { Inertia } from '@inertiajs/inertia'
import _ from 'lodash'
import Modal from '@/Shared/Modal'
import Button from '@/Shared/Button'
import { CurrencyDollarIcon, PlusIcon, CollectionIcon, XIcon, CheckIcon, UploadIcon, MicrophoneIcon, VideoCameraIcon, DocumentTextIcon, PlayIcon } from '@heroicons/vue/outline'
import Timer from 'easytimer.js'
import fixWebmDuration from 'fix-webm-duration'

const loading = ref(true)
const error = ref(null)
const showPermissionsError = ref(false)
const participants = ref(null)
const callObject = ref(null)
const p = ref(null)
const count = ref(null)
const recording = ref(false)
const timer = ref(null)
const timeRecorded = ref('00:00:00')
const recordings = ref([])
const roomName = ref(null)
const audioDevices = ref([])
const videoDevices = ref([])
const localVideo = ref(null)
const user = computed(() => usePage().props.value.auth.user)
const volume = ref(0)
const recordedChunks = ref([])
const mediaRecorder = ref(null)
const appState = ref('loading')
const sessionTitleInput = ref(null)
const sessionTitleReference = ref(null)
const startTime = ref(null)
const props = defineProps(['room', 'recordings'])
const roomInfo = ref(null)
const stream = ref(null)
const audioContext = ref(null)

const constraints = ref({
	audio: {
		echoCancellationType: 'system',
		echoCancellation: true,
		noiseSuppression: true,
		sampleRate:24000,
		sampleSize:16,
		channelCount:2,
	},
	video: false
})

onBeforeUnmount(() => {
	audioContext.value = null
	mediaRecorder.value = null
})

onMounted(() => {
	if (!props.room.uuid) {
		createRoom()
			.then((res) => {
				roomInfo.value = res
				window.history.replaceState(null, '', res.url)
				if (res.staleRoom.uuid) {
					if (confirm('Restore previous recording session (' + res.staleRoom.title + ')?')) {
						axios.patch(route('rooms.update', {room: res.uuid, deactivate: true}))
						Inertia.get(route('recordings.create', res.staleRoom.uuid))
						setTimeout(adjustInputWidth, 100)
					} else {
						axios.patch(route('rooms.update', {room: res.staleRoom.uuid, deactivate: true}))
						setTimeout(adjustInputWidth, 100)
					}
				}
			})
	} else {
		roomInfo.value = props.room
		recordings.value = props.recordings
		setTimeout(adjustInputWidth, 100)
	}
})

const micCheck = () => {
	requestMediaPermissions({audio: true, video: false})
	.then((e) => {
		setupDeviceList()
		navigator.mediaDevices
		.getUserMedia(constraints.value)
		.then((stream) => {
			stream.value = stream
			appState.value = 'idle'
			setupMediaRecorder(stream)
			getVolume(stream)
			// if (window.URL) {
			// 	localVideo.value.srcObject = stream
			// } else {
			// 	localVideo.value.src = stream
			// }
		})

		loading.value = false
		// joinRoom({userName: 'Simon', name: props.room.uuid})
	})
	.catch((MediaPermissionsError) => {
		loading.value = false
		const { type, name, message } = MediaPermissionsError
		if (type === MediaPermissionsErrorType.SystemPermissionDenied) {
			// browser does not have permission to access camera or microphone
			showPermissionsError.value = true
		} else if (type === MediaPermissionsErrorType.UserPermissionDenied) {
			// user didn't allow app to access camera or microphone
			showPermissionsError.value = true
		} else if (type === MediaPermissionsErrorType.CouldNotStartVideoSource) {
			// camera is in use by another application (Zoom, Skype) or browser tab (Google Meet, Messenger Video)
			showPermissionsError.value = true
			// (mostly Windows specific problem)
		} else {
			// not all error types are handled by this library
			showPermissionsError.value = true
		}
	})
}

micCheck()

const map = (value, x1, y1, x2, y2) => (value - x1) * (y2 - x2) / (y1 - x1) + x2

const getVolume = (stream) => {
	audioContext.value = new AudioContext()
	const analyser = audioContext.value.createAnalyser()
	const audioSource = audioContext.value.createMediaStreamSource(stream)

    analyser.fftSize = 512
    analyser.minDecibels = -105
    analyser.maxDecibels = 0
    analyser.smoothingTimeConstant = 0.7
    audioSource.connect(analyser)
    const volumes = new Uint8Array(analyser.frequencyBinCount)

    const volumeCallback = () => {
    	analyser.getByteFrequencyData(volumes)
    	let volumeSum = 0
    	for(const volume of volumes)
    		volumeSum += volume
    	const averageVolume = volumeSum / volumes.length
    	volume.value = map(Math.pow(averageVolume, 1.1), 0, 100, 1, 2)
    	window.requestAnimationFrame(volumeCallback)
    }
    volumeCallback()
}

const setupDeviceList = () => {
	navigator.mediaDevices.enumerateDevices().then((devices) => {
		audioDevices.value = devices.filter((d) => d.kind === 'audioinput')
		videoDevices.value = devices.filter((d) => d.kind === 'videoinput')
	})
}

const joinRoom = async ({ userName, name }) => {
    let roomInfo = { name }

    if (!name) {
      roomInfo = await createRoom()
    }

    const options = {
      url: 'https://pager.daily.co/' + roomInfo?.name,
      userName: userName,
    }

    if (!name) {
	    let newToken = await createToken(roomInfo?.name, userName)
	    options.token = newToken?.token
    }

    const call = daily.createCallObject({
        audioSource: true,
        videoSource: true,
        dailyConfig: {
            experimentalChromeVideoMuteLightOff: true,
        },
    })

    callObject.value = call

    call
        .join(options)
        .then((e) => {
        		roomName.value = roomInfo.name
        	})
        .catch((err) => { throw new Error(err) })

	await call.on('joining-meeting', handleJoiningMeeting)
		.on('joined-meeting', updateParticpants)
		.on('participant-joined', updateParticpants)
		.on('participant-updated', updateParticpants)
		.on('participant-left', updateParticpants)
		.on('error', handleError)
		.on('camera-error', handleDeviceError)
		.on('app-message', updateMessages)
		.on('recording-started', handleRecordingStarted)
		.on('recording-stopped', handleRecordingStopped)
}

const createRoom = async (remote = false) => {
    const response = await axios.post(route('rooms.store'), {remote: remote})
    const result = await response.data
    return result
}

const createToken = async (roomName, userName) => {
    const response = await axios.post(route('recordings.createToken', {'room_name': roomName, 'user_name': userName }))
    const result = await response.data
    return result
}

const handleJoiningMeeting = async () => {

}

const updateParticpants = () => {
	if (!callObject.value) return

	p.value = callObject.value.participants()
	count.value = Object.values(p.value).length
	participants.value = Object.values(p.value)

	loading.value = false
}

const handleError = async () => {

}

const handleDeviceError = async () => {

}

const updateMessages = async () => {

}

const handleRecordingStarted = async (e) => {
	await axios.post(route('recordings.store', {'room_name': roomName.value})).then((res) => {
		recordings.value.push(res.data)
	})
    recording.value = true
    startTimer()
}

const handleRecordingStopped = async () => {
	recording.value = false
    stopTimer()
    await axios.patch(route('recordings.update', { recording: recordings.value[recordings.value.length - 1].uuid}))
        .then((res) => {
        	console.log(res)
        })
}

const setupMediaRecorder = (stream) => {
	var options = {mimeType: 'audio/webm'}
	mediaRecorder.value = new MediaRecorder(stream, options)
	mediaRecorder.value.ondataavailable = handleDataAvailable
	mediaRecorder.value.onstart = handleLocalRecordingStarted
	mediaRecorder.value.onstop = handleLocalRecordingStopped
}

const toggleRecording = async () => {
	if (!recording.value) {
		if (!callObject.value) {
			mediaRecorder.value.start()
		} else {
			await callObject.value.startRecording()
		}
	} else {
		if (!callObject.value) {
			mediaRecorder.value.stop()
		} else {
			await callObject.value.stopRecording()
		}
	}
}

const handleLocalRecordingStarted = async () => {
	recordings.value.push({
		startedAt: Math.floor(Date.now() / 1000),
		title: 'Take ' + (recordings.value.length + 1) + ': ' + roomInfo.value.title,
		room: roomInfo.value.uuid,
		uuid: null,
		progress: null,
		duration: {
			string: '00:00:00',
			sec: 0,
		},
		s3key: null,
		previewUrl: null,
		status: 'recording',
		participants: [
			{
				name: user.value.name,
				avatar: user.value.avatar,
			}
		]
	})
	startTimer()
	startTime.value = Date.now()
	recording.value = true
}

const handleLocalRecordingStopped = async () => {
	let currentRecording = recordings.value[recordings.value.length - 1]
	currentRecording['status'] = 'uploading'
	sidePanels.value[0]['active'] = true
	let duration = Date.now() - startTime.value

	var blob = new Blob(recordedChunks.value, {
		type: 'audio/webm'
	})

	const fixedBlob = await fixWebmDuration(blob, duration, {logger: false})

	var file = new File([fixedBlob], Math.floor(Date.now() / 1000) + '-' + user.value.uuid, {
		lastModified: new Date().getTime(),
		type: fixedBlob.type
	})

    const response = await Vapor.store(file, {
        progress: progress => {
        	currentRecording['progress'] = Math.round(progress * 100)
        }
    })

    currentRecording['s3key'] = response.key
    currentRecording['uuid'] = response.uuid

	await axios.post(route('recordings.store', {recording: currentRecording})).then((res) => {
		currentRecording['previewUrl'] = res.data.previewUrl
		currentRecording['status'] = 'finished'
		currentRecording['title'] = res.data.title
		currentRecording['uuid'] = res.data.uuid
	})

	resetTimer()
	recording.value = false
}

const handleDataAvailable = (event) => {
    if (event.data.size > 0) {
    	startTimer()
    	recording.value = true
    	recordedChunks.value.push(event.data)
    }
}

const startTimer = () => {
    timer.value = new Timer()
    timer.value.start({ precision: 'secondTenths', target: {seconds: 1800} })
    timer.value.addEventListener('secondTenthsUpdated', (e) => {
        timeRecorded.value = timer.value.getTimeValues().toString(['hours', 'minutes', 'seconds'])
        let currentRecording = recordings.value.find(rec => rec.status == 'recording')
        if (currentRecording) {
        	currentRecording.duration.string = timer.value.getTimeValues().toString()
        	currentRecording.duration.sec = timer.value.getTotalTimeValues().seconds
        }
    })
    timer.value.addEventListener('targetAchieved', (e) => {
        callObject.value.stopRecording()
    })
    timer.value.addEventListener('reset', (e) => {
        timer.value.stop()
        timeRecorded.value = '00:00.0'
    })
}

const stopTimer = () => {
    timer.value.stop()
}

const resetTimer = () => {
    timer.value.reset()
    timer.value.removeAllEventListeners('secondsUpdated')
    timer.value.removeAllEventListeners('targetAchieved')
}

const removeRecording = (recording) => {
	const filteredItems = recordings.value.filter(item => item !== recording)
	recordings.value = filteredItems
}


const sidePanels = ref([
	{
		name: 'Recordings',
		// component: SidebarNotes,
		icon: PlayIcon,
		active: false,
	}
])

const toggleSidepanel = (selectedSidePanel) => {
	sidePanels.value.forEach(sidePanel => {
		if (sidePanel.name = selectedSidePanel.name) {
			sidePanel.active = !sidePanel.active
		} else {
			sidePanel.active = false
		}
	})
}

const adjustInputWidth = () => {
	let width = sessionTitleReference.value.clientWidth
	sessionTitleInput.value.style.width = width + 'px'
}

const handleTitleChange = (e) => {
	appState.value = 'working'
	axios.patch(route('rooms.update', roomInfo.value.uuid), {title: e.target.value})
		.then(res => {
			roomInfo.value.title = res.data.title
			appState.value = 'idle'
			setTimeout(adjustInputWidth, 100)
		})
}

</script>